import { UnappliedPaymentSearchDto } from './dto/unapplied-payment-search.dto';
import { ApiService } from '../../../shared/api/api.service';
import { Injectable } from '@angular/core';
import { PagedResultGeneric } from 'src/app/shared';
import { UnappliedPaymentDto } from './dto/unapplied-payment.dto';
import { UnappliedPaymentSearchResultDto } from './dto/unapplied-payment-search-result.dto';
import { InvoicePaymentDto } from '../invoice-payment/dto/invoice-payment.dto';

@Injectable({
  providedIn: 'root',
})
export class UnappliedPaymentService {
  constructor(private _apiService: ApiService) {}

  search(searchDto: UnappliedPaymentSearchDto): Promise<UnappliedPaymentSearchResultDto> {
    return this._apiService.post('UnappliedPayments/Search', searchDto);
  }

  create(dto: UnappliedPaymentDto): Promise<number> {
    return this._apiService.post('UnappliedPayments', dto);
  }

  delete(id: number): Promise<void> {
    return this._apiService.delete(`UnappliedPayment/${id}`);
  }

  getPayments(id: number): Promise<InvoicePaymentDto[]> {
    return this._apiService.get(`UnappliedPayment/${id}/Payments`);
  }
}
